import type { AuthPermissionUser } from '../../services/authPermissions';

export interface BoardAccessUser extends AuthPermissionUser {
  id?: string | null;
}

export interface BoardAccessTask {
  createdById?: string | null;
}

const BOARD_PRIVATE_TASK_ROLES = ['ADMIN', 'PARTNER', 'TESTER'];

export function canCreatePrivateBoardTask(user: BoardAccessUser | null | undefined): boolean {
  return BOARD_PRIVATE_TASK_ROLES.includes(user?.role || '');
}

export function canEditBoardTaskHours(user: BoardAccessUser | null | undefined): boolean {
  return user?.role === 'TESTER';
}

export function canSeeBoardTaskComments(user: BoardAccessUser | null | undefined): boolean {
  return user?.role === 'TESTER';
}

export function canDeleteBoardTask(
  task: BoardAccessTask | null | undefined,
  user: BoardAccessUser | null | undefined
): boolean {
  return Boolean(task?.createdById && task.createdById === user?.id) || user?.role === 'ADMIN';
}
